import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { DateRangePicker } from '@/view/components/DateRangePicker'
import { DateRange } from 'react-day-picker'
import { format, parse } from 'date-fns'

export default function Dates() {
  const { setValue, watch } = useFormContext<FilterFormData>()

  const startDate = watch('startDate')
  const endDate = watch('endDate')

  const handleDateChange = (dateRange: DateRange | undefined) => {
    if (dateRange?.from) {
      setValue('startDate', format(dateRange.from, 'yyyy-MM-dd'))
    } else {
      setValue('startDate', undefined)
    }

    if (dateRange?.to) {
      setValue('endDate', format(dateRange.to, 'yyyy-MM-dd'))
    } else {
      setValue('endDate', undefined)
    }
  }

  const parseDate = (dateStr: string | undefined) => {
    if (!dateStr) return undefined
    return parse(dateStr, 'yyyy-MM-dd', new Date())
  }

  const currentDateRange: DateRange | undefined =
    startDate && endDate
      ? {
          from: parseDate(startDate),
          to: parseDate(endDate),
        }
      : startDate
        ? { from: parseDate(startDate), to: undefined }
        : undefined

  return (
    <>
      <h2 className="font-medium text-black04">Data</h2>
      <DateRangePicker date={currentDateRange} onDateChange={handleDateChange} />
    </>
  )
}
